import type { SearchFiltersByName } from '#/modules/search/types/FiltersByName/SearchFiltersByName';

import { algoliaQueryStringArrayFilter } from './algoliaQueryStringArrayFilter';
import { algoliaQueryStringFilter } from './algoliaQueryStringFilter';

export function algoliaBuildFilterString(filters: SearchFiltersByName): string {
  const { type, ...filtersWithoutType } = filters;

  const validFilters = Object.entries(filtersWithoutType).filter(([_, value]) =>
    Array.isArray(value) ? value.length > 0 : !['', undefined].includes(value),
  );

  const filterStrings = validFilters.map(([filter, value]) => {
    if (Array.isArray(value)) {
      return algoliaQueryStringArrayFilter(filter, value);
    }

    return algoliaQueryStringFilter(filter, value);
  });

  // @NOTE - Remove this when `actionType` is not longer on the back-end
  // This is used to filter PETITION and DONATION which are `actionType`
  // records we do not want included in our search results
  if (type === 'VOLOP') {
    filterStrings.push(algoliaQueryStringFilter('actionType', 'VOLOP'));
  }

  if (type === 'EVENT') {
    filterStrings.push(algoliaQueryStringFilter('actionType', 'EVENT'));
  }

  if (type === 'VOLOP') {
    // @TODO Figure out a better way to handle IMPORTED / VOLOP
    // listings having different types, yet both being volops
    filterStrings.unshift(
      algoliaQueryStringArrayFilter('type', ['VOLOP', 'IMPORTED']),
    );
  } else if (type === 'EVENT') {
    // @TODO Figure out a better way to handle IMPORTED / EVENT
    // listings having different types, yet both being events
    filterStrings.unshift(
      algoliaQueryStringArrayFilter('type', ['EVENT', 'IMPORTED']),
    );
  } else {
    filterStrings.unshift(algoliaQueryStringFilter('type', type));
  }

  return filterStrings.join(' AND ');
}
